import React from 'react'
import { Ratings } from '@notino/react-styleguide'

// styles
import * as SC from './TestimonialsSectionStyles'
import { HomePageContainer } from '../../HomePageStyles'

// types
import { CmsHomepageData } from '../../../../types/types'

type Props = {
	cmsData: CmsHomepageData['npTestimonialsData']
}

// component
const TestimonialsSection = (props: Props) => {
	const { cmsData } = props
	const { title, testimonials } = cmsData

	const hasMoreThanThreeTestimonials = testimonials.length > 3

	return (
		<section>
			<HomePageContainer>
				<SC.SectionTitle $marginBottom={'24px'} $textAlign={'center'}>
					{title}
				</SC.SectionTitle>
				<SC.Layout $hasMoreThanThreeTestimonials={hasMoreThanThreeTestimonials}>
					{testimonials.map((testimonial, index) => {
						return (
							<SC.TestimonialCard key={index}>
								<SC.TestimonialHeading>
									<Ratings
										ratingId={testimonial.ratingId}
										rating={testimonial.rating}
										size={14}
										foreground={'text.highlight'}
										background={'background.tertiary'}
									/>
									<SC.ReviewerName>{testimonial.name}</SC.ReviewerName>
								</SC.TestimonialHeading>
								<SC.TestimonialTitle>{testimonial.title}</SC.TestimonialTitle>
								<SC.TestimonialText>{testimonial.text}</SC.TestimonialText>
							</SC.TestimonialCard>
						)
					})}
				</SC.Layout>
			</HomePageContainer>
		</section>
	)
}

export default TestimonialsSection
